module.exports = __webpack_public_path__ + "static/img/382A4A_0_0.4f93c9d.svg";